import React, { Component } from "react";
import {
    Divider,
    Row,
    Col,
} from "antd";
import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import GenericOnClickModal from "../../buttons/genericOnClickModal";
import DetokenizedAccountDetails from "./detokenizedAccountDetails";
import ACHDetailsDownloadDocument from "../achDetailsDoc/achDetailsDoc";
import EditLastFour from "./EditLastFour";

class BankAccountDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showActDetailsModal: false,
            accountNumber: undefined,
            routingNumber: undefined,
            beneficiaryName: "",
            beneficiaryAddress: "",
            beneficiaryId: "N/A",
            accountType: "",
            bankName: "",
            bankAddress: "",
            accountTier: "",
            apiSource: "",
            showAccountTier: false,
            allowPdfDownload: false,
        };
    };

    componentDidMount = () => {
        this.updateAccountDetailsHelper();
        this.updateBeneficiaryDetailsHelper();
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.accountDetails !== this.props.accountDetails) {
            this.updateAccountDetailsHelper()
        }
        if (prevProps.beneficiaryDetails !== this.props.beneficiaryDetails) {
            this.updateBeneficiaryDetailsHelper()
        }
    }

    updateAccountDetailsHelper = () => {
        let accountDetails = this.props.accountDetails;
        if (accountDetails !== undefined) {
            this.setState({
                accountType: accountDetails.account_type,
                accountTier: accountDetails.account_tier,
                bankName: accountDetails.bank?.name,
                bankAddress: accountDetails.bank?.address?.split(":").join(", "),
                apiSource: accountDetails.source,
                showAccountTier: accountDetails.source === "UN",
                allowPdfDownload: accountDetails.source === "UN"
            });
        }

    }

    updateBeneficiaryDetailsHelper = () => {
        let beneficiaryDetails = this.props.beneficiaryDetails;
        if (beneficiaryDetails !== undefined) {
            this.setState({
                beneficiaryName: beneficiaryDetails.name,
                beneficiaryAddress: beneficiaryDetails.address.split(":").join(", "),
                beneficiaryId: beneficiaryDetails.id || "N/A",
            });
        }
    }

    render() {
        return (
            <GenericOnClickModal
                size='md'
                button={
                    <>
                        View Account details <ArrowRightOutlined />
                    </>}
                modalTitle={
                    <>
                        <Row>
                            <Col span={12}>Domestic ACH/Wire Details</Col>
                            <Col span={11} style={{ display: "flex", justifyContent: "right" }}>
                                {this.state.allowPdfDownload
                                    && this.state.accountNumber !== undefined
                                    && this.state.routingNumber !== undefined &&
                                    <ACHDetailsDownloadDocument
                                        beneficiaryName={this.state.beneficiaryName}
                                        beneficiaryAddress={this.state.beneficiaryAddress}
                                        accountNumber={this.state.accountNumber}
                                        routingNumber={this.state.routingNumber}
                                        accountType={this.state.accountType}
                                        bankName={this.state.bankName}
                                        bankAddress={this.state.bankAddress}
                                        buttonView={true}
                                    />}
                            </Col>
                        </Row>
                    </>}
                modalBody={<>

                    {this.props.bankAccountId !== undefined
                        && this.props.bankAccountId !== "" && (
                            <>
                                <EditLastFour
                                  bankAccountId={this.props.bankAccountId}
                                  lastFour={this.props.accountDetails.account_number_last_4}
                                  accountNumber={this.state.accountNumber}
                                  allowEdit={this.props.accountDetails.source !== "UN"}
                                />
                                <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                                <DetokenizedAccountDetails
                                    bankAccountId={this.props.bankAccountId}
                                    onSuccess={
                                        (response) => {
                                            this.setState({
                                                accountNumber: response.account_number,
                                            });
                                        }
                                    }
                                    field="accountNumber"
                                    label="Account Number"
                                    allowEdit={this.props.accountDetails.source !== "UN"}
                                />
                                <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                                <DetokenizedAccountDetails
                                    bankAccountId={this.props.bankAccountId}
                                    onSuccess={
                                        (response) => {
                                            this.setState({
                                                routingNumber: response.routing_number,
                                            });
                                        }
                                    }
                                    field="routingNumber"
                                    label="Routing Number"
                                    allowEdit={false}
                                />
                            </>
                        )}

                    <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                    <Row gutter={16}>
                        <Col span={12} style={{ textAlign: "left" }}>
                            <p>Account Type</p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <p>{this.state.accountType}</p>
                        </Col>
                    </Row>
                    {this.state.showAccountTier && (
                        <>
                            <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                            <Row gutter={16}>
                                <Col span={12} style={{ textAlign: "left" }}>
                                    <p>Account Tier</p>
                                </Col>
                                <Col span={12} style={{ textAlign: "right" }}>
                                    <p>{this.state.accountTier}</p>
                                </Col>
                            </Row>
                        </>
                    )
                    }
                    <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                    <Row gutter={16}>
                        <Col span={12} style={{ textAlign: "left" }}>
                            <p>Recipient/Beneficiary Name</p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            {this.state.beneficiaryId !== "N/A" ? (
                                <Link
                                    style={{ color: "#00B0F0", fontWeight: "700" }}
                                    to={`/holding-entities/details/000${this.state.beneficiaryId}`}
                                >
                                    {this.state.beneficiaryName}
                                </Link>
                            ) : (
                                <p>{this.state.beneficiaryName}</p>
                            )
                            }
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                    <Row gutter={16}>
                        <Col span={12} style={{ textAlign: "left" }}>
                            <p>Beneficiary Address</p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <p>{this.state.beneficiaryAddress}</p>
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                    <Row gutter={16}>
                        <Col span={12} style={{ textAlign: "left" }}>
                            <p>Bank Name</p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <p>{this.state.bankName}</p>
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: "-2px", marginBottom: "8px" }} />
                    <Row gutter={16}>
                        <Col span={12} style={{ textAlign: "left" }}>
                            <p>Bank Address</p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <p>{this.state.bankAddress}</p>
                        </Col>
                    </Row>
                </>}
            />
        );
    }
}

export default BankAccountDetailsModal;